<div [class]="getHostClass()">
  <td-wb-icon [iconId]="assetAllocationStatus().status === 'BALANCED' ? 'approved' : 'error'" />
  <div [translate]="'tdWb.lti.common.portfolioAssetAllocationStatus.' + assetAllocationStatus().status"></div>
  @if (assetAllocationStatus().status !== 'BALANCED') {
    <div [innerText]="getDeviance() | tdWbPercent: { format: 'n0' }"></div>
  }
</div>
